export default {
  config: {
    apiKey: 'AIzaSyCPEO16iD1GzhVAIIRvPdtPpCcc0yVh1Ok',
    authDomain: 'rathakul-backoffice.firebaseapp.com',
    databaseURL: 'https://rathakul-backoffice.firebaseio.com',
    projectId: 'rathakul-backoffice',
    storageBucket: 'rathakul-backoffice.appspot.com',
    messagingSenderId: '260638186741',
    appId: '1:260638186741:web:d514b7ca9955e5153b39bc',
    measurementId: 'G-SMNYCCVH78',
  },
};
